import React, { useState, useEffect, useMemo } from 'react';
import { Breadcrumb, BreadcrumbItem, Tile, ClickableTile, Modal, ContentSwitcher, Switch } from 'carbon-components-react';
import moment from 'moment';
import TimeFilter from './Alerts/TimeFilter';
import { getNewTimeRange } from './Alerts/TimeFilterUtil';
import AutomationOpsWorkspace from 'components/ManageAutomationPage/AutomationOpsWorkspace';
import SAPOpsWorkspace from 'components/ManageAutomationPage/SAPOpsWorkspace';
import "@carbon/charts/styles.css";
import AnchorLink from 'react-anchor-link-smooth-scroll';
import ArrowDownWhite from 'assets/image/ArrowDownWhite.svg';
import ArrowGreenDown from 'assets/image/ArrowGreenDown.svg';
import ArrowRedUp from 'assets/image/ArrowRedUp.svg';
import i18n from "../../i18n";
import * as Constants from '../../requests/URLConstants'
import callPostApi from "../../requests/PostRequests";
import * as workspaces from '../../config/WorkspaceConstants'
import OEMWorkspace from './OEMWorkspace';
import SalesForceWorkspace from './SalesForceWorkspace';
import { Button } from 'carbon-components-react';
import { Idea32, ArrowRight32, Menu20 as Menu } from '@carbon/icons-react';
import CustomOpsWorkspace from './CustomOpsWorkspace';
import * as InsightsData from './Insights/InsightsMockData';
import InsightsModal from './Insights/InsightsModal'
import callPostApiWithoutConfigURl from '../../requests/PostRequestsWithoutConfigUrl';
import callGetApiWithoutConfigURl from '../../requests/GetRequestsWithoutConfigUrl';
import SAPMonitoring from '../SAPMonitoring/SAPMonitoring';
import { ReactComponent as Cube } from 'assets/image/Cube.svg';
import * as configConst from "../../config/Constants"

require("./_manage-automation.scss");

var config = require('../../config/appConfig.json');


const ManageAutomationPage = (props) => {
    const [timeFilterSelections, setTimeFilterSelections] = useState({});
    const [workspace, setWorkspace] = useState(null);
    // const [cardInfo, setCardInfo] = useState(cards);
    const [alertTerminationMetrics, setAlertTerminationMetrics] = useState(null);
    const [alertExceptionMetrics, setAlertExceptionMetrics] = useState(null);
    const [anomaliesMetrics, setAnomaliesMetrics] = useState(null);
    const [userPrefs, setUserPrefs] = useState(null);
    const [display, setDisplay] = useState(false);
    let user = JSON.parse(localStorage.getItem('user'));
    const [alertTerminationMetricsValue, setAlertTerminationMetricsValue] = useState(null);
    const [alertTerminationMetricsDelta, setAlertTerminationMetricsDelta] = useState(null);
    const [alertExceptionMetricsValue, setAlertExceptionMetricsValue] = useState(null);
    const [alertExceptionMetricsDelta, setAlertExceptionMetricsDelta] = useState(null);
    const [resourceIssueClick, setResourceIssueClick] = useState(false);
    const [queueStatus, setQueueStatus] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);
    const [executionClick, setExecutionClick] = useState(false);
    const [anamoliesClick, setAnamoliesClick] = useState(false);
    const [SAPSelectedTab, setSAPSelectedTab] = useState(0);
    const [ExceptionCount, setExceptionCount] = useState(0);
    const [QueueStatusCount, setQueueStatusCount] = useState(0);
    const [ResourceCount, setResourceCount] = useState(0);
    const [alertSalesforceMetricsValue, setAlertSalesforceMetricsValue] = useState(null);
    const [alertSalesforceMetricsDelta, setAlertSalesforceMetricsDelta] = useState(null);
    const [alertCustomMetricsValue, setAlertCustomMetricsValue] = useState(null);
    const [alertCustomMetricsDelta, setAlertCustomMetricsDelta] = useState(null);
    const [showInsightModal, setShowInsightModal] = useState(false);
    const [CarouselIndex, setCarouselIndex] = useState(0);
    const [insightsData, setInsightsData] = useState([]);
    const [insightsTableData, setInsightsTableData] = useState([]);
    const [insightsDataLoading, setInsightsDataLoading] = useState(false);
    const [insightsCount, setInsightsCount] = useState(0);
    const [clientsByUserAccess, setClientsByUserAccess] = useState([]);
    const [customSelectedTab, setCustomSelectedTab] = useState(0);
    const [selectedView, setSelectedView] = useState('manageOperations');
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [salesforceMetrics, setSalesforceMetrics] = useState(null);
    const [salesforceSelectedTab, setSalesforceSelectedTab] = useState(0);

    useEffect(() => {
        setWorkspace(props.workspace);
        getUserPreferences(user.username);
        // updateCards();
    }, [props]);

    useEffect(() => {
        getUserPreferences(user.username, props.workspace);
        // updateCards();
    }, [props.workspace]);

    useEffect(() => {
        setSelectedView("manageOperations");
        setSelectedIndex(0);
    }, [props.workspace]);

    useEffect(() => {
        getResourceQueueCount();
        //getClientsByUserAccess();
    }, []);

    //uncomment for insights section Start
    // useEffect(() => {
    //     getInsightData();
    // }, [clientsByUserAccess]);

    // const CHECK_INTERVAL = 60000 * 5 //5 minutes;
    // useEffect(() => {
    //     let id = setInterval(() => {
    //         getInsightData();
    //         console.log("called getInsightData function")
    //     }, CHECK_INTERVAL);
    //     return () => clearInterval(id);
    // });

    // useEffect(() => {
    //     if (insightsData.length > 0) {
    //         setInsightsCount(insightsData.length);
    //     }
    // }, [insightsData]);

    // useEffect(() => {
    //     if (insightsData.length > 0 && showInsightModal === true) {
    //         getAcknowledgeData(insightsData[0])
    //     }
    // }, [insightsData, showInsightModal]);

    // useEffect(() => {
    //     if (showInsightModal === true) {
    //         const insightsDataNotif = [...insightsData];
    //         if (insightsData.length > 0) {
    //             insightsData[0]['seen'] = true;
    //         }
    //         setInsightsData(insightsDataNotif)
    //     }
    // }, [showInsightModal]);

     //uncomment for insights section End

    //console.log(anomaliesMetrics);
    const TerminationRate = i18n.t('manageAutomation.TerminationRate');
    const PredictedAnomalies = i18n.t('manageAutomation.PredictedAnomalies');
    const NumberOfExceptions = i18n.t('manageAutomation.NumberOfExceptions');
    const Summary = i18n.t('manageAutomation.Summary');
    const ResourceIssues = i18n.t('manageAutomation.ResourceIssues');
    const QueueAlerts = i18n.t('manageAutomation.QueueAlerts');
    const InfraAlerts = i18n.t('manageAutomation.InfraAlertsAutomation');
    const Insights = i18n.t('manageAutomation.Insights');
    const Informational = i18n.t('manageAutomation.Informational');
    const securityAlerts = i18n.t('sapOps.securityAlerts');
    const UserAlerts = i18n.t('manageAutomation.UserAlerts');
    /*const updateCards = (stateValue) => {
      let newCardInfo={...cardInfo};
      if (stateValue.alertMetrics) {
        let alertMetrics=stateValue.alertMetrics;
  
        let cards=newCardInfo.cards;
        let exceptionCard = cards.filter(function (item) {
          return item.eyebrow === "Executions";
        });
        if (exceptionCard) {
          parseFloat("123.456").toFixed(2);
          exceptionCard[0].heading ='Termination Rate: '+parseFloat(alertMetrics.terminationRate).toFixed(2) + '%';
          exceptionCard[0].copy= alertMetrics.exceptionCount+ ' terminations out of '+alertMetrics.totalCount+ " executions"
      }
      }
      setCardInfo(newCardInfo);
    };*/

    function getClientsByUserAccess() {
        callPostApi(Constants.GETUNIQUECLIENTS, {
            'Content-Type': 'application/json'
        })
            .then(resp => {
                let clients = resp.map(client => client.key);
                setClientsByUserAccess(clients);
            }).catch((error) => {
            })
    }

    const updateCards = (stateValue) => {
        const value = i18n.t('manageAutomation.value');
        const Delta = i18n.t('manageAutomation.delta');
        const DependencyFailures = i18n.t('manageAutomation.DependencyFailures');
        const LongRunning = i18n.t('manageAutomation.LongRunning');
        const LongPending = i18n.t('manageAutomation.LongPending');
        const infraFailures = i18n.t('sapOps.infraFailures');
        const logAnomalies = i18n.t('sapOps.logAnomalies');

        switch (stateValue.metricsType) {
            case 'alertMetrics':
                if (workspace === workspaces.automation_ops) {
                    let delta = stateValue.data.terminationRate - stateValue.data.prevTerminationRate;
                    let alertTerminationMetricsData =
                        [
                            {
                                "group": value,
                                "value": stateValue.data.terminationRate,
                            },
                            {
                                "group": Delta,
                                "value": delta,
                            }
                        ];
                    setAlertTerminationMetrics(alertTerminationMetricsData);
                    //console.log("Termination value is " + alertTerminationMetricsData[0].value + alertTerminationMetricsData[1].value)
                    setAlertTerminationMetricsValue(alertTerminationMetricsData[0].value);
                    setAlertTerminationMetricsDelta(alertTerminationMetricsData[1].value);
                } else {
                    let delta = stateValue.data.exceptionCount - stateValue.data.prevExceptionCount;
                    let alertExceptionMetricsData =
                        [
                            {
                                "group": value,
                                "value": stateValue.data.exceptionCount,
                            },
                            {
                                "group": Delta,
                                "value": delta,
                            }
                        ];
                    setAlertExceptionMetrics(alertExceptionMetricsData);
                    //console.log("Exceptions metrics value is " + alertExceptionMetricsData[0].value + alertExceptionMetricsData[1].value)
                    if (workspace === workspaces.sap_ops) {
                        setAlertExceptionMetricsValue(alertExceptionMetricsData[0].value);
                        setAlertExceptionMetricsDelta(alertExceptionMetricsData[1].value);
                    }
                    else if (workspace === workspaces.salesforce_ops) {
                        setAlertSalesforceMetricsValue(stateValue.data);
                        setAlertSalesforceMetricsDelta(0);
                    }
                    else if (workspace === workspaces.custom_ops) {
                        setAlertCustomMetricsValue(alertExceptionMetricsData[0].value);
                        setAlertCustomMetricsDelta(alertExceptionMetricsData[1].value);
                    }
                }
                break;
            case 'predictedAlertMetrics':
                let anomaliesMetricsData = []; let salesForceMetricsData = [];
                if (workspace === workspaces.automation_ops) {
                    anomaliesMetricsData = [
                        {
                            "group": DependencyFailures,
                            "value": stateValue.data.dependencyAlertsCount
                        },
                        {
                            "group": LongRunning,
                            "value": stateValue.data.longRunningAlertsCount
                        },
                        {
                            "group": LongPending,
                            "value": stateValue.data.longPendingAlertsCount
                        }
                    ]
                } else {
                    (workspace === workspaces.sap_ops || workspaces.custom_ops) && anomaliesMetricsData.push({
                        "group": infraFailures,
                        "value": stateValue.data.infraAlertsCount ? stateValue.data.infraAlertsCount : 0
                    })

                    workspace === workspaces.sap_ops && anomaliesMetricsData.push({
                        "group": logAnomalies,
                        "value": stateValue.data.logAnalyticsAlertsCount ? stateValue.data.logAnalyticsAlertsCount : 0
                    })

                    if (workspace === workspaces.custom_ops) {
                        anomaliesMetricsData.push(
                            {
                                "group": Informational,
                                "value": stateValue.data.informationalAlertsCount ? stateValue.data.informationalAlertsCount : 0
                            },
                            {
                                "group": securityAlerts,
                                "value": stateValue.data.securityAlertsCount ? stateValue.data.securityAlertsCount : 0
                            }
                        )
                    }
                    if (workspace === workspaces.salesforce_ops) {
                        salesForceMetricsData.push(
                            // {
                            //     "group": Informational,
                            //     "value": stateValue.data.informationalAlertsCount ? stateValue.data.informationalAlertsCount : 0,
                            //     "tab": "Informational",
                            // },
                            {
                                "group": UserAlerts,
                                "value": stateValue.data.userAlertsCount ? stateValue.data.userAlertsCount : 0,
                                "tab": "Incidents (User)"
                            }
                        )
                    }
                }
                setAnomaliesMetrics(anomaliesMetricsData);
                setSalesforceMetrics(salesForceMetricsData);
                break;
            default:
                break;
        }
    }

    const updateState = (state, stateValue) => {
        //console.log('got here');
        switch (state) {
            case 'timeFilterSelections':
                // setTimeFilterSelections(stateValue);
                updateUserPreferences(user.username, stateValue, null, null);
                break;
            case 'userPreferences':
                stateValue.alertFilterSelections ? updateUserPreferences(user.username, null, stateValue.alertFilterSelections, null) : updateUserPreferences(user.username, null, null, stateValue.pAlertFilterSelections);
                break;
            case 'cardInfo':
                updateCards(stateValue);
                break;
            case 'ExceptionCount':
                setExceptionCount(stateValue);
                break;
            default:
        }
    };

    const getResourceQueueCount = () => {

        callPostApi(Constants.GETRESOURCEISSUESCOUNT, {
            'Content-Type': 'application/json'
        }).then(resp => {
            setQueueStatusCount(resp.queueAlerts);
            setResourceCount(resp.resourceIssues);
        }).catch((error) => {
            console.error('Error:', error);
        });
    };

    const total = (arr) => {
        let sum = 0;

        if (!Array.isArray(arr)) {
            return isNaN(sum) ? 0 : sum;
        }
        arr.forEach(each => {
            sum += isNaN(each.value) ? 0 : each.value;
        });
        return isNaN(sum) ? 0 : sum;
    }

    const getTimeWindow = () => {
        if (timeFilterSelections.startDateTime && timeFilterSelections.endDateTime) {
            let startM = moment(timeFilterSelections.startDateTime);
            let endM = moment(timeFilterSelections.endDateTime);
            let startMStr = startM.format("l");
            let endMStr = endM.format("l");
            return startMStr + " - " + endMStr;
        }
        else {
            return "";
        }
    };

    const getStartTime = () => {
        if (timeFilterSelections.startDateTime) {
            let startM = moment(timeFilterSelections.startDateTime);
            let startMStr = startM.locale("en").format("lll");
            return startMStr;
        }
        else {
            return "";
        }
    };

    const getEndTime = () => {
        if (timeFilterSelections.endDateTime) {
            let endM = moment(timeFilterSelections.endDateTime);
            let endMStr = endM.locale("en").format("lll");
            return endMStr;
        }
        else {
            return "";
        }
    };

    const updateUserPreferences = async (user, timeFilters, alertFilters, pAlertFilters) => {
        let body = { "user": user };//, "timeFilters": timeFilters, "alertFilters": alertFilters, "pAlertFilters": pAlertFilters }
        let bodyJSON = {};
        bodyJSON.user = body.user;
        if (timeFilters) {
            bodyJSON.timeFilters = timeFilters;
        }

        let automationFilters = {};
        let sapFilters = {};
        let customFilters = {};
        let salesForceFilters = {};


        if (workspace === workspaces.automation_ops) {
            if (alertFilters) {
                automationFilters =
                {
                    'alertFilters': alertFilters,
                };
                bodyJSON.automation = automationFilters;
            }
            if (pAlertFilters) {
                automationFilters =
                {
                    'pAlertFilters': pAlertFilters,
                };
                bodyJSON.automation = automationFilters;
            }
        } else if (workspace === workspaces.sap_ops) {
            // if(respJson){
            if (alertFilters) {
                sapFilters =
                {
                    'alertFilters': alertFilters,
                };
                bodyJSON.sap = sapFilters;
            }
            if (pAlertFilters) {
                sapFilters =
                {
                    'pAlertFilters': pAlertFilters,
                };
                bodyJSON.sap = sapFilters;
            }
        } else if (workspace === workspaces.custom_ops) {
            // if(respJson){
            if (alertFilters) {
                customFilters =
                {
                    'alertFilters': alertFilters,
                };
                bodyJSON.custom = customFilters;
            }
            if (pAlertFilters) {
                customFilters =
                {
                    'pAlertFilters': pAlertFilters,
                };
                bodyJSON.custom = customFilters;
            }
        } else if (workspace === workspaces.salesforce_ops) {
            // if(respJson){
            if (alertFilters) {
                salesForceFilters =
                {
                    'alertFilters': alertFilters,
                };
                bodyJSON.salesforce = salesForceFilters;
            }
            if (pAlertFilters) {
                salesForceFilters =
                {
                    'pAlertFilters': pAlertFilters,
                };
                bodyJSON.salesforce = salesForceFilters;
            }
        }

        callPostApi(Constants.UPDATEUSERPREFRENCESURL, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                //console.log('response', resp);
                getUserPreferences(body.user, props.workspace);

            }).catch((error) => {
                console.error('Error:', error);
            });
    };

    const getUserPreferences = async (user, workspace) => {
        if (workspace) {
            setUserPrefs(null);
            let body = { 'user': user };

            let response = await callPostApi(Constants.GETUSERPREFRENCESURL, {
                'Content-Type': 'application/json'
            }, body);
            let respJson = await response;
            let userPrefs = {};
            if (respJson && respJson && respJson._source) {
                //console.log("preferences result", respJson);
                if (respJson._source.timeFilters) {
                    let timeFilter = respJson._source.timeFilters;

                    if (respJson._source.timeFilters.timeRangeType === "relative") {
                        timeFilter = getNewTimeRange(respJson._source.timeFilters.timeRange);
                        timeFilter.timeInterval = (respJson._source.timeFilters.timeInterval);
                    }
                    setTimeFilterSelections(timeFilter);
                } else {
                    setDefaultTimeFilter();
                }

                //console.log("Workspace",workspace);

                if (workspace === workspaces.automation_ops) {
                    if (respJson._source.automation && respJson._source.automation.pAlertFilters) {
                        userPrefs.pAlertFilters = respJson._source.automation.pAlertFilters;
                    }
                    if (respJson._source.automation && respJson._source.automation.alertFilters) {
                        userPrefs.alertFilters = respJson._source.automation.alertFilters;
                    }

                } else if (workspace === workspaces.sap_ops) {
                    if (respJson._source.sap && respJson._source.sap.pAlertFilters) {
                        userPrefs.pAlertFilters = respJson._source.sap.pAlertFilters;
                    }
                    if (respJson._source.sap && respJson._source.sap.alertFilters) {
                        userPrefs.alertFilters = respJson._source.sap.alertFilters;
                    }
                } else if (workspace === workspaces.custom_ops) {
                    if (respJson._source.custom && respJson._source.custom.pAlertFilters) {
                        userPrefs.pAlertFilters = respJson._source.custom.pAlertFilters;
                    }
                    if (respJson._source.custom && respJson._source.custom.alertFilters) {
                        userPrefs.alertFilters = respJson._source.custom.alertFilters;
                    }
                } else if (workspace === workspaces.salesforce_ops) {
                    if (respJson._source.salesforce && respJson._source.salesforce.pAlertFilters) {
                        userPrefs.pAlertFilters = respJson._source.salesforce.pAlertFilters;
                    }
                    if (respJson._source.salesforce && respJson._source.salesforce.alertFilters) {
                        userPrefs.alertFilters = respJson._source.salesforce.alertFilters;
                    }
                }


            } else {
                setDefaultTimeFilter();
            }
            setUserPrefs(userPrefs);
            setDisplay(true);
        }
    }
    const setDefaultTimeFilter = () => {
        var selections = {};
        let endMoment = moment();
        let strEndMoment = endMoment.format();
        var formatedEndDate = endMoment.format('l');
        var formattedEndTime = endMoment.format('hh:mm');
        var endAMPM = endMoment.format('A');
        let startMoment = endMoment.subtract({ hours: 24 });
        let strStartMoment = startMoment.format();
        var formatedStartDate = startMoment.format('l');
        var formattedStartTime = startMoment.format('hh:mm');
        var startAMPM = startMoment.format('A');
        selections.startDateTime = strStartMoment
        selections.startDate = formatedStartDate;
        selections.startTime = formattedStartTime;
        selections.startAMPM = startAMPM;
        selections.endDateTime = strEndMoment;
        selections.endDate = formatedEndDate;
        selections.endTime = formattedEndTime;
        selections.endAMPM = endAMPM;
        selections.timeInterval = 0;
        selections.timeRangeType = "relative";  // relative , absolute
        selections.timeRange = "1D"; // can be 15m, 30m, 1H, 1D, 7D, 1M, 3M, 6M, 1Y, WTD, MTD, YTD
        setTimeFilterSelections(selections);
    }

    const toggleInsightModal = () => {
        setShowInsightModal(!showInsightModal);
    }

    function handleResourceIssues() {
        setResourceIssueClick(true);
        setQueueStatus(false);
        setExecutionClick(false);
        setAnamoliesClick(false);
    }

    function handleQueueStatus() {
        setQueueStatus(true);
        setResourceIssueClick(false);
        setExecutionClick(false);
        setAnamoliesClick(false);
    }

    function handleAnomaliesClick(event, metricsName, index) {
        console.log(metricsName, index);
        setSelectedTab(metricsName);
        if (resourceIssueClick === true || queueStatus === true) {
            if (metricsName === 'Long Running' || 'Long Pending' || 'Infra Alerts' || 'Dependency Failures' || 'Informational Alerts') {
                setResourceIssueClick(false);
                setQueueStatus(false);
                setAnamoliesClick(true);
            }
        }
    }

    // function handleInfraAlertsClick(event, metricsName, index) {
    //     setSelectedTab(metricsName);
    // }

    function handleExecutionsClick() {
        setExecutionClick(true);
        setResourceIssueClick(false);
        setQueueStatus(false);
        setAnamoliesClick(false);
    }

    function handleSAPAnamoliesClick(metricsName, index) {
        console.log(metricsName, index);
        setSAPSelectedTab(metricsName);
    }

    function handleCustomAnamoliesClick(metricsName, index) {
        console.log(metricsName, index);
        setCustomSelectedTab(metricsName);
    }

    function handleSalesforceAnamoliesClick(metricsName) {
        setSalesforceSelectedTab(metricsName);
    }
    function handleTabSelected(tabName) {
        setSAPSelectedTab(tabName);
    }

    function handleAutomationTabSelected(tabName) {
        setSelectedTab(tabName);
    }

    function handleCustomTabSelected(tabName) {
        setCustomSelectedTab(tabName);
    }

    function handleSalesforceTabSelected(tabName) {
        setSalesforceSelectedTab(tabName);
    }
    const handleInsightsUpdate = (state, value) => {
        switch (state) {
            case 'CorousalData':
                setInsightsData(value);
                break;
            case 'CorousalDataCount':
                setInsightsCount(value);
                break;
            default:
        }
    }

    const handleCarouselSelect = (selectedIndex, e) => {
        insightsData.length > 0 && getAcknowledgeData(insightsData[selectedIndex]);
        let insightsDataNotification = [...insightsData];
        for (let i = 0; i <= insightsData.length; i++) {
            if (insightsData[selectedIndex]) {
                insightsData[selectedIndex].seen = true;
            }
        }
        //insightsData.splice(selectedIndex - 1, 1);
        setInsightsData(insightsDataNotification);
        setCarouselIndex(selectedIndex);
        console.log(insightsCount, "insightsCount", selectedIndex, e);
        //console.log("eventvalue", e);
        // if (insightsCount) {
        //     decreaseInsightsCount(selectedIndex);
        // }
    };

    // const decreaseInsightsCount = (selectedIndex) => {
    //     if (insightsCount <= 1) {
    //         setInsightsCount("");
    //         return;
    //     } else {
    //         setInsightsCount(insightsCount - 1);
    //         console.log("DEC", insightsCount);
    //     }
    // }

    const getInsightData = () => {
        setInsightsDataLoading(true);
        let formattedData = [];
        var data = JSON.stringify({
            "userId": user.username,
            "clientname": "DEVSECOPS",
            //"clientname": clientsByUserAccess,
            "appname": "",
            "createdtime": ""
        });
        callPostApiWithoutConfigURl(Constants.GETINSIGHTS, {
            'Content-Type': 'application/json',
            'Authorization': 'Basic ZG91c2VyOkRAcHcwMDlrczEyOUg=',
        }, data)
            .then(resp => {
                //formattedData = prepareInsightData(InsightsData.InsightsCarouselData);
                formattedData = prepareInsightData(resp);
                setInsightsData(formattedData.carouselData);
                setInsightsTableData(formattedData.tableData);
                setInsightsDataLoading(false);
            }).catch((error) => {
                setInsightsDataLoading(false);
            });
    }

    const prepareInsightData = (response) => {

        let tableData = [];
        let tableObj = {};
        let carouselData = [];
        let carouselObj = {};

        if (response) {
            let bucket = response;
            for (let i = 0; i < bucket.length; i++) {
                tableObj = {
                    id: (i + 1).toString(),
                    name: bucket[i]._source.sonar_message.Application_Name,
                    client: bucket[i]._source.sonar_message.Engagement.name,
                    details: bucket[i]._source.sonar_message.Error_description,
                    documentId: bucket[i]._id,
                    acknowledged: bucket[i]._source.acknowledged[0] ? bucket[i]._source.acknowledged[0] : "",
                    date: moment(bucket[i]._source.sonar_message.Error_date).format('lll'),
                    error_title: bucket[i]._source.sonar_message.Error_message
                }
                carouselObj = {
                    id: (i + 1).toString(),
                    name: bucket[i]._source.sonar_message.Application_Name,
                    client: bucket[i]._source.sonar_message.Engagement.name,
                    details: bucket[i]._source.sonar_message.Error_description,
                    documentId: bucket[i]._id,
                    acknowledged: bucket[i]._source.acknowledged,
                    date: moment(bucket[i]._source.sonar_message.Error_date).format('lll'),
                    error_title: bucket[i]._source.sonar_message.Error_message,
                    isAcknowledged: false //default value
                }
                let acknowledgedBucket = bucket[i]._source.acknowledged ? bucket[i]._source.acknowledged : [""];
                for (let j = 0; j < acknowledgedBucket.length; j++) {
                    if (acknowledgedBucket[j] === user.username) {
                        carouselObj.isAcknowledged = true;
                    }
                }
                tableData.push(tableObj);
                carouselData.push(carouselObj);
            }
        }
        //console.log(carouselData, "carouselData")
        carouselData = carouselData.filter(value => (value.isAcknowledged === false));
        return { tableData, carouselData };
    }

    const getAcknowledgeData = (data) => {
        let bodyJSON = {
            "documentId": data.documentId,
            "userId": user.username
        }
        if (data.isAcknowledged === false) {
            callPostApiWithoutConfigURl(Constants.UPDATEINSIGHTS, {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ZG91c2VyOkRAcHcwMDlrczEyOUg=',
            }, bodyJSON).then(resp => {
            }).catch((error) => {
                console.error('Error:', error);
            });
        }
    };

    const switchView = (e) => {
        setSelectedView(e);
        if (e === 'topologyView') {
            //the index is set as 2 because it is the third element in switcher, second is the verticle line
            setSelectedIndex(2);
        }
        else if (e === 'manageOperations') {
            setSelectedIndex(0);
        }
    };

    const renderTimeFilter = useMemo(() => {
        return <TimeFilter updateState={updateState} timeFilterSelections={timeFilterSelections}></TimeFilter>
    }, [timeFilterSelections])

    if (user !== null && user.access_token !== null) {
        const Home = i18n.t('manageAutomation.Home');
        const ManageOperations = i18n.t('manageAutomation.ManageOperations');
        const busSysAlerts = i18n.t('manageAutomation.businessAndSystemAlerts');
        const SysAlerts = i18n.t('manageAutomation.SystemAlerts');
        const otherAnomalies = i18n.t('manageAutomation.otherAnomalies');
        const Current = i18n.t('manageAutomation.Current');
        const predictedAnamolies = i18n.t('manageAutomation.predictedAnamolies');
        const Total = i18n.t('manageAutomation.Total');
        const Monitoring = i18n.t('manageAutomation.Monitoring');
        return (
            <div className={workspace === workspaces.sap_ops && selectedView === "topologyView" ? "topology-container" : "bx--grid--full-width"} >
                {showInsightModal && (configConst.URL.includes(configConst.staging) || configConst.URL.includes(configConst.development) || configConst.URL.includes(configConst.local)) &&
                    <InsightsModal insightCarousalRows={insightsData} insightTableRows={insightsTableData} CarouselIndex={CarouselIndex}
                        insightsTableHeaders={InsightsData.InsightsHeaders} showInsightModal={showInsightModal} handleCarouselSelect={handleCarouselSelect}
                        toggleInsightModal={toggleInsightModal} insightsDataLoading={insightsDataLoading} insightsCount={insightsCount} handleInsightsUpdate={handleInsightsUpdate}
                        getAcknowledgeData={getAcknowledgeData} />
                } 


                {/* uncomment for insights section */}
                {selectedView !== "topologyView" && (configConst.URL.includes(configConst.staging) || configConst.URL.includes(configConst.development) || configConst.URL.includes(configConst.local)) &&
                    <Button className="do-notification insight" iconDescription={Insights} onClick={toggleInsightModal} renderIcon={Idea32}>
                        <span className='text'>{Insights}</span>
                        {insightsData.filter(val => val.seen !== true).length > 0 ?
                            <span className="circle"> {insightsData.filter(val => val.seen !== true).length}</span>
                            :
                            ''
                        }
                    </Button>
                }
                <div className="bx--row manage-automation-page__banner" style={{
                    background: workspace === workspaces.sap_ops && selectedView === "topologyView" ? "black" : "transparent",
                    borderBottom: workspace === workspaces.sap_ops && (configConst.URL.includes(configConst.staging) || configConst.URL.includes(configConst.development) || configConst.URL.includes(configConst.local)) ? "#979797 solid 1px" : "none"
                }}>
                    <div className="bx--col-lg-4 carbon-display-Regular-14 breadcrumb-container">
                        {workspace === workspaces.automation_ops || workspace === workspaces.sap_ops || workspace === workspaces.salesforce_ops ?
                            <Breadcrumb noTrailingSlash aria-label="Page navigation">
                                <BreadcrumbItem classname="bread-crump" href='/homepage'>
                                    {Home}
                                </BreadcrumbItem>
                                <BreadcrumbItem href='/manage_operations' isCurrentPage={workspace === workspaces.sap_ops && selectedView === "topologyView" ? false : true}>
                                    {ManageOperations}
                                </BreadcrumbItem>
                                {/* {workspace === workspaces.sap_ops && selectedView === "topologyView" &&
                                <BreadcrumbItem href='#' isCurrentPage={false}>
                                    {"Topology Observability"}
                                </BreadcrumbItem>} */}
                            </Breadcrumb> : null}
                    </div>
                    {workspace === workspaces.sap_ops && (configConst.URL.includes(configConst.staging) || configConst.URL.includes(configConst.development) || configConst.URL.includes(configConst.local)) &&
                        <div className="bx--col-lg-8 ">
                            <ContentSwitcher selectedIndex={selectedIndex} onChange={(e) => switchView(e.name)} className="topology-view-switcher">
                                <Switch name={'manageOperations'} text={<Menu />} />
                                <hr width="1" className="verticle-line" style={{ background: selectedView === "topologyView" ? "white" : "#979797" }} />
                                <Switch name={'topologyView'} text={<Cube />} style={{ fill: selectedView === "topologyView" ? "white" : "#6F6F6F" }} />
                            </ContentSwitcher>

                        </div>}
                    {workspace === workspaces.sap_ops && selectedView === "topologyView" ?
                        null
                        :
                        <div className='time-filter bx-col-lg-4' >
                            <div className="margin-top-10px startTime carbon-display-Regular-14">{getStartTime()}</div>
                            <div className="margin-top-10px margin-left-10px  margin-right-10px">{'-'}</div>
                            <div className="margin-top-10px endTime carbon-display-Regular-14">{getEndTime()}</div>
                            <div className="time-filter-button" >
                                {renderTimeFilter}
                            </div>
                        </div>
                    }
                </div>
                {workspace === workspaces.automation_ops ?
                    <div className="bx--row manage-automation-page-cards">
                        {alertTerminationMetrics && anomaliesMetrics ?
                            <><div className="border-tile summary-tile">
                                <div className="tile-heading summary-head carbon-display-Regular-14" style={{ marginLeft: '0px!important' }}>{Summary}</div>
                                <Tile className='summary-value'><div className="summary-card" >{Monitoring}</div> </Tile>
                            </div>
                                <div className="border-tile">
                                    <div className="tile-heading carbon-display-Regular-14">{TerminationRate}</div>
                                    <div className="chart-border">
                                        {/*  <CardGroup cards={cards.cards} />*/}
                                        {alertTerminationMetrics ?
                                            // <GaugeChart
                                            //   data={alertTerminationMetrics}
                                            //   options={options}>
                                            // </GaugeChart>
                                            <div>
                                                <Tile>
                                                    <div className="card-title carbon-display-Regular-14">{Current}</div>
                                                    <div className="termination-delta">
                                                        <div className="termination-value">
                                                            {alertTerminationMetricsValue ?
                                                                <div className="alert-termination">
                                                                    <div className="card-body">{alertTerminationMetricsValue.toFixed(2)}</div>
                                                                    <div className="terminatio-percentage">%</div>
                                                                </div>
                                                                : <div className="dash">-</div>}
                                                        </div>
                                                        {alertTerminationMetricsDelta ?
                                                            alertTerminationMetricsDelta > 0 ?
                                                                <div className={alertTerminationMetricsValue ? "alert-termination-delta" : "alert-termination-delta empty"}>
                                                                    <div className="img-redArrow"><img src={ArrowRedUp} alt="" /></div>
                                                                    <div className="card-footer red-text">{alertTerminationMetricsDelta.toFixed(2)} %</div>
                                                                </div>
                                                                :
                                                                <div className="alert-termination-delta">
                                                                    <div className="img-arrow"><img src={ArrowGreenDown} alt="" /></div>
                                                                    <div className="card-footer green-text">{alertTerminationMetricsDelta.toFixed(2)} %</div>
                                                                </div>
                                                            : null}
                                                    </div>
                                                </Tile>
                                            </div>
                                            : null}
                                    </div>
                                </div>
                                <div className="border-tile-predicted">
                                    <div className="predicted-arrow">
                                        <div className="tile-heading carbon-display-Regular-14">{PredictedAnomalies}</div>
                                        <div className="arrow-icon-predicted">
                                            <AnchorLink href={'#' + 'Predicted_Anomalies'}>
                                                <img src={ArrowDownWhite} alt="" />
                                            </AnchorLink>
                                        </div>
                                    </div>
                                    <div className="predicted-values">
                                        <ClickableTile handleClick={handleExecutionsClick}>
                                            <div className="card-title carbon-display-Regular-14">{NumberOfExceptions}</div>
                                            {/* <div className="card-body">{total(anomaliesMetrics)}</div> */}
                                            <div className="card-body">{ExceptionCount}</div>
                                        </ClickableTile>
                                        {anomaliesMetrics.map((entry, index) =>
                                            <div>

                                                <AnchorLink href={'#' + 'Predicted_Anomalies'}>
                                                    <ClickableTile handleClick={(event) => handleAnomaliesClick(event, entry.group, index)}>
                                                        <div className="card-title carbon-display-Regular-14">{entry.group}</div>
                                                        <div className="card-body">{entry.value}</div>
                                                    </ClickableTile>
                                                </AnchorLink>


                                            </div>
                                        )}
                                        <AnchorLink href={'#' + 'Predicted_Anomalies'}>
                                            {/* <ClickableTile handleClick={(event) => handleAnomaliesClick(event, "Infra Alerts", "3")}>
                                            <div className="card-title carbon-display-Regular-12">{InfraAlerts}</div>
                                            <div className="card-body">45</div>
                                        </ClickableTile > */}
                                        </AnchorLink>
                                        <ClickableTile handleClick={handleResourceIssues}>
                                            <div className="card-title carbon-display-Regular-12">{ResourceIssues}</div>
                                            <div className="card-body">{ResourceCount}</div>
                                        </ClickableTile >
                                        <ClickableTile handleClick={handleQueueStatus}>
                                            <div className="card-title carbon-display-Regular-12">{QueueAlerts}</div>
                                            <div className="card-body">{QueueStatusCount}</div>
                                        </ClickableTile >
                                    </div>
                                </div> </>
                            : null}
                        {/* <div className='time-filter'>
                            <div className="margin-top-10px startTime carbon-display-Regular-14">{getStartTime()}</div>
                            <div className="margin-top-10px margin-left-10px  margin-right-10px">{'-'}</div>
                            <div className="margin-top-10px endTime carbon-display-Regular-14">{getEndTime()}</div>
                            <div className="time-filter-button" >
                                <TimeFilter updateState={updateState} timeFilterSelections={timeFilterSelections}></TimeFilter>
                            </div>
                        </div> */}
                    </div>
                    :
                    workspace === workspaces.sap_ops && selectedView === "topologyView" ?
                        < SAPMonitoring workspace={workspace} />
                        :
                        <div className="bx--row manage-automation-page-cards">
                            {alertExceptionMetrics ?
                                <>
                                    <div className="border-tile summary-tile">
                                        <div className="tile-heading carbon-display-Regular-14">{Summary}</div>
                                        <Tile className='summary-value'><div className="summary-card">{Monitoring}</div> </Tile>
                                    </div>
                                    <div className="border-tile">
                                        <div className="tile-heading carbon-display-Regular-14">{workspace === workspaces.salesforce_ops ? SysAlerts : busSysAlerts}</div>
                                        <div className="chart-border">
                                            {/*  <CardGroup cards={cards.cards} />*/}
                                            <div>
                                                {alertExceptionMetrics ?
                                                    <Tile>
                                                        <div className="card-title carbon-display-Regular-14">{workspace === workspaces.salesforce_ops ? "" : Current} </div>
                                                        <div className="termination-delta">
                                                            <div className="termination-value">
                                                                {(workspace === workspaces.salesforce_ops ? alertSalesforceMetricsValue > 0 : workspace === workspaces.custom_ops ? alertCustomMetricsValue > 0 : alertExceptionMetricsValue > 0) ?
                                                                    <div className="card-body">{workspace === workspaces.salesforce_ops ? alertSalesforceMetricsValue : workspace === workspaces.custom_ops ? alertCustomMetricsValue : alertExceptionMetricsValue}</div> : <div className="card-body">0</div>}
                                                            </div>
                                                            {(workspace === workspaces.salesforce_ops ? alertSalesforceMetricsDelta : workspace === workspaces.custom_ops ? alertCustomMetricsDelta : alertExceptionMetricsDelta) ?
                                                                (workspace === workspaces.salesforce_ops ? alertSalesforceMetricsDelta > 0 : workspace === workspaces.custom_ops ? alertCustomMetricsDelta > 0 : alertExceptionMetricsDelta > 0) ?
                                                                    <div className={(workspace === workspaces.salesforce_ops ? alertSalesforceMetricsDelta : workspace === workspaces.custom_ops ? alertCustomMetricsDelta : alertExceptionMetricsDelta) ? "alert-termination-delta" : "empty"}>
                                                                        <div className="img-redArrow"><img src={ArrowRedUp} alt="" /></div>
                                                                        <div className="card-footer red-text">{workspace === workspaces.salesforce_ops ? alertSalesforceMetricsDelta : workspace === workspaces.custom_ops ? alertCustomMetricsDelta : alertExceptionMetricsDelta}</div>
                                                                    </div>
                                                                    :
                                                                    <div className="alert-termination-delta">
                                                                        <div className="img-alertException"><img src={ArrowGreenDown} alt="" /></div>
                                                                        <div className="card-footer green-text">{workspace === workspaces.salesforce_ops ? alertSalesforceMetricsDelta : workspace === workspaces.custom_ops ? alertCustomMetricsDelta : alertExceptionMetricsDelta}</div>
                                                                    </div>
                                                                : null}
                                                        </div>
                                                    </Tile>

                                                    : null}
                                            </div>
                                        </div>
                                    </div>
                                    {workspace !== workspaces.salesforce_ops ?
                                        <div className="border-tile-predicted sap">
                                            <div className="predicted-arrow">
                                                <div className="tile-heading carbon-display-Regular-14">{otherAnomalies}</div>
                                                <div className="arrow-icon-predicted">
                                                    <AnchorLink href={'#' + 'Predicted_Anomalies'}>
                                                        <img src={ArrowDownWhite} alt="" />
                                                    </AnchorLink>
                                                </div>
                                            </div>
                                            <div className="predicted-values">
                                                <Tile className='total-tile'>
                                                    <div className="card-title carbon-display-Regular-14">{Total}</div>
                                                    <div className="card-body">{total(anomaliesMetrics)}</div>
                                                </Tile>
                                                {anomaliesMetrics ? anomaliesMetrics.map((entry, index) =>
                                                    <div>
                                                        <AnchorLink href={'#' + 'Predicted_Anomalies'}>
                                                            <ClickableTile handleClick={(event) => workspace === workspaces.custom_ops ? handleCustomAnamoliesClick(entry.group, index) : handleSAPAnamoliesClick(entry.group, index)}>
                                                                <div className="card-title carbon-display-Regular-14">{entry.group}</div>
                                                                <div className="card-body">{entry.value}</div>
                                                            </ClickableTile>
                                                        </AnchorLink>
                                                    </div>
                                                ) : null}
                                            </div>

                                        </div> : null}
                                    {workspace === workspaces.salesforce_ops ?
                                        <>
                                            {salesforceMetrics ? salesforceMetrics.map((entry, index) => <div className="border-tile-predicted sap">
                                                <div className="predicted-arrow">
                                                    <div className="tile-heading carbon-display-Regular-14">{entry.group}</div>
                                                </div>
                                                <div className="predicted-values">
                                                    {/* <Tile className='total-tile'>
                                                    <div className="card-title carbon-display-Regular-14">{"Informational"}</div>
                                                    <div className="card-body">{total(salesforceMetrics)}</div>
                                                </Tile> */}
                                                    <div>
                                                        <ClickableTile handleClick={(event) => handleSalesforceAnamoliesClick(entry.tab)}>
                                                            {/* <div className="card-title carbon-display-Regular-14">{entry.group}</div> */}
                                                            <div className="card-title carbon-display-Regular-14"></div>
                                                            <div className="card-body">{entry.value}</div>
                                                        </ClickableTile>
                                                    </div>
                                                </div>
                                            </div>) : null}
                                        </>
                                        : null}
                                </> : null}
                        </div>

                }

                <div className="page-margin">

                    <div className="manage-automation-page-timeFilter">
                        {/* <div className="monitor carbon-display-Regular-28">{Monitoring}</div> */}

                        {/* <div className="bx--col-lg-3 bx--offset-lg-11 bx--col-md-3 time--range-display">
              {getTimeWindow()}
            </div> */}


                    </div>


                    {display ?
                        (workspace === workspaces.automation_ops &&
                            <AutomationOpsWorkspace
                                updateState={updateState}
                                userPrefs={userPrefs}
                                workspace={workspace}
                                timeFilterSelections={timeFilterSelections}
                                resourceIssue={resourceIssueClick}
                                queueStatus={queueStatus}
                                selectedTab={selectedTab}
                                executionClick={executionClick}
                                anamoliesClick={anamoliesClick}
                                handleTabSelected={handleAutomationTabSelected}
                            />
                        )
                        || (workspace === workspaces.sap_ops &&
                            selectedView !== "topologyView" &&
                            <SAPOpsWorkspace
                                updateState={updateState}
                                userPrefs={userPrefs}
                                workspace={workspace}
                                timeFilterSelections={timeFilterSelections}
                                selectedTab={SAPSelectedTab}
                                handleTabSelected={handleTabSelected}
                            />)
                        || (workspace === workspaces.oem_ops && <OEMWorkspace updateState={updateState} userPrefs={userPrefs} workspace={workspace} timeFilterSelections={timeFilterSelections} />)
                        || (workspace === workspaces.salesforce_ops && <SalesForceWorkspace updateState={updateState} userPrefs={userPrefs} workspace={workspace} timeFilterSelections={timeFilterSelections} selectedTab={salesforceSelectedTab} handleTabSelected={handleSalesforceTabSelected} />)
                        || (workspace === workspaces.custom_ops && <CustomOpsWorkspace updateState={updateState} userPrefs={userPrefs} workspace={workspace} timeFilterSelections={timeFilterSelections} selectedTab={customSelectedTab} handleTabSelected={handleCustomTabSelected} />)
                        : null}
                </div >
            </div>
        );
    } else {
        return (
            <div>
                <p><h2>Please<a href={`https://development.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/login`}> sign up. </a> </h2> </p>
            </div>
        );
    }
};

export default ManageAutomationPage;
